import { Dispatch } from 'redux';
import { isEmpty } from 'lodash';
import { organizationActions } from '../slices/organization-slice';
import { ApiOrganization } from '../http';

const {
  setOrganizationRequestStart,
  setOrganizationRequestSuccess,
  setOrganizationRequestFailure,
  setOrganizationRequestDefault,

  setOrganizationListRequest,
  setOrganizationListSuccess,
  setOrganizationListFailure,
  setOrganizationListDefault,

  setOrganizationOneRequest,
  setOrganizationOneSuccess,
  setOrganizationOneFailure,
  setOrganizationOneDefault,

  setOrganizationWarehouseRequest,
  setOrganizationWarehouseSuccess,
  setOrganizationWarehouseFailure,
  setOrganizationWarehouseDefault,
} = organizationActions;

//List
export const getOrganizations =
  (params: Record<string, any>) => async (dispatch: Dispatch<any>) => {
    dispatch(setOrganizationListRequest());
    try {
      const data = await ApiOrganization.fetchAll(params);
      dispatch(setOrganizationListSuccess(data));
    } catch ({ message }) {
      dispatch(setOrganizationListFailure({ message }));
    }
  };
export const clearOrganizations = () => async (dispatch: Dispatch<any>) => {
  dispatch(setOrganizationListDefault());
};

//One
export const getOrganization = (id: string | number) => async (dispatch: Dispatch<any>) => {
  dispatch(setOrganizationOneRequest());
  try {
    const data = await ApiOrganization.fetchOne(id);
    dispatch(setOrganizationOneSuccess(data));
  } catch ({ message }) {
    dispatch(setOrganizationOneFailure({ message }));
  }
};
export const clearOrganization = () => async (dispatch: Dispatch<any>) => {
  dispatch(setOrganizationOneDefault());
};

//Warehouse
export const forceGetOrganizationWarehouse = () => async (dispatch: Dispatch<any>) => {
  dispatch(setOrganizationWarehouseRequest());
  try {
    const data = await ApiOrganization.fetchAll({ take: 9999 });
    dispatch(setOrganizationWarehouseSuccess(data));
  } catch ({ message }) {
    dispatch(setOrganizationWarehouseFailure({ message }));
  }
};
export const getOrganizationWarehouse = () => async (dispatch: Dispatch<any>, getState: any) => {
  const storeStates = getState();
  const { warehouse } = storeStates.organization;
  if (isEmpty(warehouse.hits) && !warehouse.isLoading) {
    dispatch(forceGetOrganizationWarehouse());
  }
};
export const clearOrganizationWarehouse = () => async (dispatch: Dispatch<any>) => {
  dispatch(setOrganizationWarehouseDefault());
};

//Create
export const createOrganization =
  (data: Record<string, any>) => async (dispatch: Dispatch<any>) => {
    dispatch(setOrganizationRequestStart());
    return new Promise((resolve, reject) => {
      ApiOrganization.createOne(data)
        .then((res) => {
          dispatch(setOrganizationRequestSuccess());
          resolve(res);
        })
        .catch((res) => {
          dispatch(setOrganizationRequestFailure({ message: res?.message }));
          reject(res);
        });
    });
  };

//Edit
export const editOrganization =
  (id: string | number, data: Record<string, any>) => async (dispatch: Dispatch<any>) => {
    dispatch(setOrganizationRequestStart());
    return new Promise((resolve, reject) => {
      ApiOrganization.updateOne(id, data)
        .then((res) => {
          dispatch(setOrganizationRequestSuccess());
          resolve(res);
        })
        .catch((res) => {
          dispatch(setOrganizationRequestFailure({ message: res?.message }));
          reject(res);
        });
    });
  };

//Delete
export const deleteOrganization = (id: string | number) => async (dispatch: Dispatch<any>) => {
  dispatch(setOrganizationRequestStart());
  return new Promise((resolve, reject) => {
    ApiOrganization.deleteOne(id)
      .then((res) => {
        dispatch(setOrganizationRequestSuccess());
        resolve(res);
      })
      .catch((res) => {
        dispatch(setOrganizationRequestFailure({ message: res?.message }));
        reject(res);
      });
  });
};

//Clear request
export const clearOrganizationRequest = () => async (dispatch: Dispatch<any>) => {
  dispatch(setOrganizationRequestDefault());
};
